import React, { useState, useEffect } from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import { supabase } from '../../supabaseClient';

const PasswordReset: React.FC = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (error) {
          setMessage('Error: ' + error.message);
          return;
        }
        if (!data.session) {
          const hashParams = new URLSearchParams(window.location.hash.substring(1));
          const accessToken = hashParams.get('access_token');
          const refreshToken = hashParams.get('refresh_token');
          if (accessToken && refreshToken) {
            const { error: sessionError } = await supabase.auth.setSession({
              access_token: accessToken,
              refresh_token: refreshToken,
            });
            if (sessionError) setMessage('Error setting session: ' + sessionError.message);
          }
        }
      } catch (err) {
        setMessage('An unexpected error occurred.');
      }
    };
    init();
  }, []);

  const handlePasswordReset = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setMessage('Password must be at least 6 characters long.');
      return;
    }
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) {
        setMessage('Error resetting password: ' + error.message);
      } else {
        setMessage('Password has been reset successfully! You can now log in with your new password.');
        setPassword('');
        setConfirmPassword('');
      }
    } catch (err) {
      setMessage('An unexpected error occurred while updating your password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter and confirm your new password"
      footer={<>
        Remembered your password? <a href="/login">Log in</a>
      </>}
    >
      <form onSubmit={handlePasswordReset}>
        <label className="label" htmlFor="password">New password</label>
        <input className="input" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />

        <label className="label" htmlFor="confirmPassword">Confirm new password</label>
        <input className="input" id="confirmPassword" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={6} />

        {message && <div style={{ color: message.includes('Error') ? '#ff6b6b' : '#9be564', fontSize: 14 }}>{message}</div>}

        <div className="auth-actions">
          <button className="button full" type="submit" disabled={loading}>{loading ? 'Resetting…' : 'Reset password'}</button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default PasswordReset; 